const HELCIM_SCRIPT_ID = "helcim-pay-script";
const HELCIM_SCRIPT_SRC = "https://secure.helcim.app/helcim-pay/services/start.js";

let helcimScriptPromise: Promise<void> | null = null;

declare global {
  interface Window {
    appendHelcimPayIframe?: (
      token: string,
      allowExit?: boolean,
      email?: string,
    ) => void;
    removeHelcimPayIframe?: () => void;
  }
}

export const loadHelcimPayScript = (): Promise<void> => {
  if (window.appendHelcimPayIframe) return Promise.resolve();
  if (helcimScriptPromise) return helcimScriptPromise;

  helcimScriptPromise = new Promise<void>((resolve, reject) => {
    const existingScript = document.getElementById(
      HELCIM_SCRIPT_ID,
    ) as HTMLScriptElement | null;
    const script = existingScript ?? document.createElement("script");

    const handleLoad = () => {
      cleanup();

      if (window.appendHelcimPayIframe) {
        resolve();
        return;
      }

      helcimScriptPromise = null;
      reject(new Error("Helcim Pay loaded without exposing its checkout API."));
    };

    const handleError = () => {
      cleanup();
      helcimScriptPromise = null;
      script.remove();
      reject(new Error("Unable to load the secure Helcim payment form."));
    };

    const cleanup = () => {
      script.removeEventListener("load", handleLoad);
      script.removeEventListener("error", handleError);
    };

    script.addEventListener("load", handleLoad, { once: true });
    script.addEventListener("error", handleError, { once: true });

    if (!existingScript) {
      script.id = HELCIM_SCRIPT_ID;
      script.src = HELCIM_SCRIPT_SRC;
      script.async = true;
      document.head.appendChild(script);
    }
  });

  return helcimScriptPromise;
};
